import { render, staticRenderFns } from "./Veriff.vue?vue&type=template&id=7c077ca7&"
import script from "./Veriff.vue?vue&type=script&lang=js&"
export * from "./Veriff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports